// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/views/pendingDeletion/index.css
// module id = 2026
// module chunks = 0